const sectionStyle = {
  maxWidth: "1100px",
  margin: "0 auto",
  padding: "60px 20px"
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: "20px"
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: "12px",
  padding: "20px",
  background: "#fff",
  transition: "all 0.2s ease"
};

const hoverEffect = (e, enter = true) => {
  e.currentTarget.style.boxShadow = enter
    ? "0 10px 25px rgba(0,0,0,0.08)"
    : "none";
  e.currentTarget.style.transform = enter
    ? "translateY(-2px)"
    : "translateY(0)";
};

const AwsArchitecture = () => {
  const sectionStyle = {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "60px 20px"
  };

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "20px"
  };

  const cardStyle = {
    border: "1px solid #eee",
    borderRadius: "12px",
    padding: "20px",
    background: "#fff",
    transition: "all 0.2s ease"
  };

  return (
    <div>

      {/* HERO */}
      <div style={{ ...sectionStyle, paddingTop: "80px" }}>
        <h1 style={{ fontSize: "42px", marginBottom: "20px" }}>
          AWS Consulting & Architecture
        </h1>

        <p style={{
          fontSize: "20px",
          color: "#555",
          maxWidth: "700px"
        }}>
          Design scalable, secure, and cost-efficient AWS systems tailored to your business.
          From initial architecture to modernization of existing platforms.
        </p>

        <div style={{ marginTop: "30px" }}>
          <a href="/contact" style={{
            padding: "14px 28px",
            background: "#007bff",
            color: "#fff",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "500"
          }}>
            Book a Consultation
          </a>
        </div>
      </div>


      {/* PROBLEMS */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "30px" }}>Challenges I Help Solve</h2>

        <div style={gridStyle}>
            {[
            "Designing scalable and resilient cloud architectures from scratch",
            "Modernizing legacy monolithic systems into microservices or serverless",
            "Reducing high AWS costs caused by inefficient architecture",
            "Ensuring security, compliance, and data protection in cloud environments",
            "Designing event-driven and distributed systems for high throughput",
            "Integrating multiple systems across enterprise environments",
            "Handling performance bottlenecks and system instability",
            "Establishing cloud architecture standards and best practices"
            ].map((item, i) => (
            <div
                key={i}
                style={cardStyle}
                onMouseEnter={(e) => hoverEffect(e, true)}
                onMouseLeave={(e) => hoverEffect(e, false)}
            >
                {item}
            </div>
            ))}
        </div>
      </div>


      {/* WHAT YOU GET */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "30px" }}>What You Get</h2>

        <div style={gridStyle}>
        {[
        "Tailored AWS architecture aligned with your business and technical goals",
        "High-level and low-level architecture diagrams",
        "Service selection and design decisions based on best practices",
        "Cost-optimized architecture design",
        "Security-first architecture (IAM, encryption, isolation)",
        "Scalability and high-availability design",
        "Clear implementation roadmap for development teams",
        "Guidelines for maintainability and future evolution"
        ].map((item, i) => (
        <div
            key={i}
            style={cardStyle}
            onMouseEnter={(e) => hoverEffect(e, true)}
            onMouseLeave={(e) => hoverEffect(e, false)}
        >
            {item}
        </div>
        ))}
        </div>
      </div>


      {/* PROCESS */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "30px" }}>How I Work</h2>

        <div style={gridStyle}>
        {[
        "Understand business goals, constraints, and domain context",
        "Assess current systems, architecture, and bottlenecks",
        "Define target architecture (high-level and component-level)",
        "Select appropriate AWS services and architectural patterns",
        "Design for scalability, resilience, and fault tolerance",
        "Incorporate security, compliance, and cost optimization",
        "Provide implementation roadmap and technical guidelines",
        "Support teams during implementation if required"
        ].map((step, i) => (
        <div
            key={i}
            style={cardStyle}
            onMouseEnter={(e) => hoverEffect(e, true)}
            onMouseLeave={(e) => hoverEffect(e, false)}
        >
            <strong>Step {i + 1}:</strong> {step}
        </div>
        ))}
        </div>
      </div>

    <div style={{ ...sectionStyle, background: "#fafafa" }}>
    <h2 style={{ marginBottom: "30px" }}>Architecture Capabilities</h2>

    <div style={gridStyle}>
        {[
        "Serverless and event-driven architectures",
        "Microservices and distributed systems design",
        "High-availability and fault-tolerant systems",
        "Multi-environment (dev/test/prod) architecture design",
        "Secure cloud architecture (IAM, encryption, network isolation)",
        "Data architecture and processing pipelines",
        "Integration architecture across systems and services",
        "Cloud-native transformation and system modernization"
        ].map((item, i) => (
        <div
            key={i}
            style={cardStyle}
            onMouseEnter={(e) => hoverEffect(e, true)}
            onMouseLeave={(e) => hoverEffect(e, false)}
        >
            {item}
        </div>
        ))}
    </div>
    </div>

      {/* TECHNOLOGIES (PREMIUM GRID) */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "30px" }}>
          Technologies & AWS Expertise
        </h2>

        <div style={gridStyle}>
        {[
            {
            title: "Compute",
            icon: "⚙️",
            items: ["Lambda", "EC2", "ECS", "EKS", "Fargate"]
            },
            {
            title: "Storage",
            icon: "🗄️",
            items: ["S3", "EBS", "EFS", "Glacier"]
            },
            {
            title: "Databases",
            icon: "🛢️",
            items: ["DynamoDB", "RDS", "Aurora", "PostgreSQL", "Oracle"]
            },
            {
            title: "Integration",
            icon: "🔗",
            items: ["API Gateway", "SNS", "SQS", "EventBridge", "Step Functions"]
            },
            {
            title: "Networking",
            icon: "🌐",
            items: ["VPC", "Route 53", "CloudFront", "ALB / NLB"]
            },
            {
            title: "Security",
            icon: "🔐",
            items: ["IAM", "KMS", "Secrets Manager", "Cognito"]
            },
            {
            title: "DevOps",
            icon: "🚀",
            items: ["CloudFormation", "AWS SAM", "Terraform", "CI/CD"]
            },
            {
            title: "Observability",
            icon: "📊",
            items: ["CloudWatch", "X-Ray", "CloudTrail"]
            },
            {
            title: "Data & AI",
            icon: "🤖",
            items: ["Bedrock", "Textract", "Comprehend", "Translate"]
            }
        ].map((section, i) => (
            <div
            key={i}
            style={cardStyle}
            onMouseEnter={(e) => hoverEffect(e, true)}
            onMouseLeave={(e) => hoverEffect(e, false)}
            >
            <h3>{section.icon} {section.title}</h3>

            <ul style={{ paddingLeft: "18px", color: "#555" }}>
                {section.items.map((item, j) => (
                <li key={j}>{item}</li>
                ))}
            </ul>
            </div>
        ))}
        </div>
      </div>

        {/* FINAL CTA */}
        <div style={{
        textAlign: "center",
        margin: "100px 0",
        padding: "60px 20px",
        background: "#fafafa"
        }}>
        <h2 style={{
            fontSize: "32px",
            marginBottom: "16px"
        }}>
            Let’s design your AWS architecture
        </h2>

        <p style={{
            color: "#555",
            fontSize: "18px",
            marginBottom: "32px",
            maxWidth: "600px",
            marginLeft: "auto",
            marginRight: "auto",
            lineHeight: "1.6"
        }}>
            Get practical guidance and a clear path to production-ready systems.
        </p>

        <a href="/contact" style={{
            display: "inline-block",
            padding: "16px 36px",
            background: "#007bff",
            color: "#fff",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "500",
            fontSize: "16px",
            transition: "all 0.2s ease",
            boxShadow: "0 8px 20px rgba(0,0,0,0.1)"
        }}
        onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
        }}
        onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
        }}
        >
            Schedule a Call
        </a>
        </div>      

    </div>
  );
};

export default AwsArchitecture;